// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { gql } from '@apollo/client';
export type MinimalClientOrganizationFragment = { __typename?: 'ClientOrganization', id: string, name: string, kind?: Types.ClientOrganizationKind | null };

export type ClientOrganizationFragment = (
  { __typename?: 'ClientOrganization', pointOfContactName?: string | null, pointOfContactLastName?: string | null, pointOfContactPhone?: string | null, pointOfContactEmail?: string | null, address?: { __typename?: 'Address', id: string, cityName?: string | null, stateCode: string } | null }
  & MinimalClientOrganizationFragment
);

export const Operations = {
  Fragment: {
    MinimalClientOrganization: 'MinimalClientOrganization' as const,
    ClientOrganization: 'ClientOrganization' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const MinimalClientOrganizationFragmentDoc = gql`
    fragment MinimalClientOrganization on ClientOrganization {
  id
  name
  kind
}
    `;
export const ClientOrganizationFragmentDoc = gql`
    fragment ClientOrganization on ClientOrganization {
  ...MinimalClientOrganization
  pointOfContactName
  pointOfContactLastName
  pointOfContactPhone
  pointOfContactEmail
  address {
    id
    cityName
    stateCode
  }
}
    ${MinimalClientOrganizationFragmentDoc}`;